var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncementsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.265,
    height: 21.245,
    viewBox: "0 0 22.265 21.245",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160",
    "data-name": "Group 160",
    transform: "translate(0.233 0.234)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    "data-name": "Path 505",
    d: "M20.265,1.69V16.735c0,1.937-2.633,2-4.224-.135-1.231-1.652-3.911-1.652-5.457-1.665H3.306A3.094,3.094,0,0,1,.551,11.589V7.935c0-1.933,1.291-3.5,2.882-3.5h7.1a8.046,8.046,0,0,0,5.506-2.584C17.723-.058,20.223.352,20.265,1.69Z",
    transform: "translate(-0.233 -0.233)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1.102
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    "data-name": "Path 506",
    d: "M9.517,25.682v4.323a1.38,1.38,0,0,1-1.383,1.383h-.94a1.38,1.38,0,0,1-1.383-1.383V25.682Z",
    transform: "translate(-2.461 -10.878)",
    fill: "#fff",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    y2: 10.496,
    transform: "translate(5.788 4.02)",
    fill: "none",
    stroke: "gray",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_507",
    "data-name": "Path 507",
    d: "M34.753,17.735a4.621,4.621,0,0,0,0-6.813",
    transform: "translate(-14.72 -5.061)",
    fill: "none",
    stroke: "gray",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncementsIcon);
export default __webpack_public_path__ + "static/media/announcements_icon.043fb98f0e900d0d65cb76e24324a48d.svg";
export { ForwardRef as ReactComponent };